import { render, staticRenderFns } from "./queries-sidebar.vue?vue&type=template&id=13c4809e"
import script from "./queries-sidebar.vue?vue&type=script&lang=js"
export * from "./queries-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports